import Vue from 'vue'
import Router from 'vue-router'
import NaviBar from "../components/NaviBar"
import navi from "../components/navi"
import Vfooter from "../components/footer"
import  banner from  "../components/banner"
import  Varticle from  "../components/article"
import  notfound from  "../veiws/notfound"
import  standardMenu from  "../veiws/standardMenu"
import  standardA from  "../veiws/standardA"
import  standardB from  "../veiws/standardB"
import  standardC from  "../veiws/standardC"

//显示声明使用Router
Vue.use(Router)

//配置导出路由
export default new Router({
  mode: "hash",
  routes:[
    { // 配置默认路由
      path:"/", // 路由地址
      redirect:"/home" // 重定向
    },
    {
      //路由路径
      path:'/home',
      component: ()=> import('../veiws/home'),
      name: 'home',
      meta: {
        title: '首页'
      },
    },
    {
      //路由路径
      path:'/price',
      component: () => import('../veiws/price'),//懒加载
      name: 'price',
      meta: {
        title: '价格行情'
      },
    },
    {
      path:'/standard',
      component: () => import('../veiws/standard'),//懒加载
      name: 'standard',
      meta: {
        title: '行业标准'
      },
    },
    {
      path:'/standardView',
      component: () => import('../veiws/standardView'),//懒加载
      name: 'standardView',
      meta: {
        title: '行业标准'
      },
    },
    {
      path:'/project',
      component: () => import('../veiws/project'),//懒加载
      name: 'project',
      meta: {
        title: '项目成果'
      },
    },
    {
      path:'/policy',
      component: () => import('../veiws/policy'),//懒加载
      name: 'policy',
      meta: {
        title: '相关政策'
      },
    },
    {
      path:'/ScientificResearch',
      component: () => import('../veiws/ScientificResearch'),//懒加载
      name: 'ScientificResearch',
      meta: {
        title: '科研成果'
      },
    },
    {
      path:'/articleDetail',
      component: () => import('../veiws/articleDetail'),//懒加载
      name: 'articleDetail',
      meta: {
        title: '文章详情'
      },
    },
    {
      path:'/minerals',
      component: () => import('../veiws/minerals'),//懒加载
      name: 'minerals',
      meta: {
        title: '矿产资源'
      },
    },
    {
      //路由路径
      path:'/NaviBar',
      name: 'NaviBar',
      //跳转组件
      component: NaviBar
    },
    {
      //路由路径
      path:'/banner',
      name: 'banner',
      //跳转组件
      component: banner
    },
    {
      //路由路径
      path:'/article',
      name: 'Varticle',
      //跳转组件
      component: Varticle
    },
    {
      //路由路径
      path:'/navi',
      name: 'navi',
      //跳转组件
      component: navi
    },
    {
      //路由路径
      path:'/standardMenu',
      name: 'standardMenu',
      //跳转组件
      component: standardMenu
    },
    {
      //路由路径
      path:'/standardA',
      name: 'standardA',
      //跳转组件
      component: standardA
    },
    {
      //路由路径
      path:'/standardB',
      name: 'standardB',
      //跳转组件
      component: standardB
    },
    {
      //路由路径
      path:'/standardC',
      name: 'standardC',
      //跳转组件
      component: standardC
    },
    {
      //路由路径
      path:'/footer',
      name: 'Vfooter',
      //跳转组件
      component: Vfooter
    },
    {
      //路由路径
      path:'*',
      name: 'notfuond',
      //跳转组件
      component: notfound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js